import { BaseService, Service } from "/@/cool";
@Service("model")
class Goods extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["glbForRepairReject"] = prefix + "glbForRepairReject";
	}

	glbForRepairReject(params: any) {
		return this.request({
			url: "/glbForRepairReject",
			method: "POST",
			data: {
				...params
			}
		});
	}
}
export default Goods;
